export default __webpack_public_path__ + "static/media/5.3a0c7477.png";